import { render, staticRenderFns } from "./SubmitExam.vue?vue&type=template&id=f9c08c30"
import script from "./SubmitExam.vue?vue&type=script&lang=js"
export * from "./SubmitExam.vue?vue&type=script&lang=js"
import style0 from "./SubmitExam.vue?vue&type=style&index=0&id=f9c08c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports